export default __webpack_public_path__ + "static/agency_uos-eb660a079bc827aa9b593f3388e038c9.jpg";